import { AlertOctagon, Clock } from "lucide-react";

/** Overlapping-bookings / vehicle-unavailable-during-booking conflict pill.
 * Clicking opens the affected booking (handled by the caller via onClick). */
export function ConflictBadge({ kind, count, onClick, testId }) {
  if (!count) return null;
  const label = kind === "state"
    ? `Vehicle unavailable: ${count} booking${count === 1 ? "" : "s"} affected`
    : `${count} overlapping booking${count === 1 ? "" : "s"}`;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-red-100 text-red-800 border border-red-200 text-[10px] font-semibold hover:bg-red-200"
      title={label}
    >
      <AlertOctagon className="w-3 h-3" />
      {label}
    </button>
  );
}

/** Tight-turnaround / impossible-turnaround buffer warning pill. Presentation
 * tiering only (gap < 1h vs gap < company buffer): no new detection math,
 * both come straight from conflict_service.detect_conflicts()'s
 * buffer_warnings, tiered server-side in fleet_calendar/service.py. */
export function BufferWarningBadge({ warning, onClick, testId }) {
  if (!warning) return null;
  const isImpossible = warning.tier === "impossible_turnaround";
  const gapLabel = warning.gap_hours < 1
    ? `${Math.round(warning.gap_hours * 60)} min turnaround`
    : `${warning.gap_hours}h turnaround (needs ${warning.buffer_required}h)`;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full border text-[10px] font-semibold hover:opacity-80 ${
        isImpossible ? "bg-red-100 text-red-800 border-red-200" : "bg-amber-100 text-amber-800 border-amber-200"
      }`}
      title={`${gapLabel} between ${warning.booking_a.booking_reference} and ${warning.booking_b.booking_reference}`}
    >
      <Clock className="w-3 h-3" />
      {isImpossible ? "Impossible turnaround" : "Tight buffer"} · {gapLabel}
    </button>
  );
}
